module.exports = __webpack_public_path__ + "static/media/halloween11.02f57dd2.jpg";